import { parseISO } from 'date-fns';

const parseIsoDate = (value: string, options?: { isDateTraining?: boolean }) => {
  if (options?.isDateTraining || /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return parseISO(value);
  }

  const hasTimezone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(value);

  return parseISO(hasTimezone ? value : `${value}Z`);
};

export default parseIsoDate;
